var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        width: "100%",
        height: "calc(100vh - 70px)",
        "box-sizing": "border-box",
        "background-color": "#fff",
      },
    },
    [
      _vm.activeName === "1"
        ? _c("Schedule", { ref: "Schedule", attrs: { treeShow: true } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }